import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import store from "./store";


Vue.use(Router);
let router = new Router({
    mode: "history",
    routes: [{
        path: "/",
        props: true,
        component: () =>
            import("./layout/Default"),
        meta: {
            requiresAuth: true,
        },
        children: [{
            path: "",
            name: "dashboard",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Dashboard/Dashboard"),
        },
        {
            path: "add",
            name: "adds",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./layout/Admins/addMenu"),
        },
        {
            path: "CategoryList",
            name: "CategoryList",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Category/category"),
        },
        {
            path: "/orientation",
            name: "orientation",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Orientation/orientation"),
        },
        {
            path: "/orientation-view",
            name: "orientation-view",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Orientation/orientation-view"),
        },
        {
            path: "/download",
            name: "download",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Download/download"),
        },
        {
            path: "/download-view",
            name: "download-view",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Download/download-view"),
        },
        {
            path: "/employee-comparison",
            name: "EmployeeComparison",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/EmployeeComparison"),
        },
        {
            path: "/TitleList",
            name: "JobTitle",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Title/title"),
        },
        {
            path: "/removed-jobs",
            name: "removed-jobs",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Title/removedJobs"),
        },
        {
            path: "/volunteer",
            name: "volunteerTitle",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/volunteerTitle/title"),
        },
        {
            path: "Applications",
            name: "JobApplications",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Applications/applications"),
            props: true,
        },
        {
            path: "volunteerApplication",
            name: "volunteerApplications",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/volunteerApplication/applications"),
        },
        {
            path: "viewApplication",
            name: "viewApplication",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Applications/viewApplication"),
            props: true,
        },
        {
            path: "viewVolunteerApplication",
            name: "viewVolunteerApplication",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/volunteerApplication/viewApplication"),
        },
        //Employee document
        {
            path: "employeedocument",
            name: "employeeDocument",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/EmployeeDocument/documents"),
        },
        {
            path: "viewdocument",
            name: "viewdocument",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/EmployeeDocument/viewDoc"),
        },




        {
            path: "YourApplications",
            name: "YourApplications",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Applications/documents"),
        },
        {
            path: "YourDocInfo",
            name: "YourDocInfo",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Applications/documentInfo"),
        },
        {
            path: "nominationForm",
            name: "nominationForm",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Applications/nominationForm"),
        },
        {
            path: "epfoForm",
            name: "epfoForm",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Applications/epfoForm"),
        },


        {
            path: "YourDocInfoView",
            name: "YourDocInfoView",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/documentInfoView"),
        },

        {
            path: "/careerGraph",
            name: "careerGraph",
            props: true,
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/careerGraph"),
        },
        {
            path: "/careerGraphEmp",
            name: "careerGraphEmp",
            props: true,
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/careerGraphEmp"),
        },
        {
            path: "/CareerGraphDivision",
            name: "CareerGraphDivision",
            meta: { requiresAuth: true },
            component: () => import("./views/CareerGraph/CareerGraphDivision")
        },
        {
            path: "/CareerGraphUpload",
            name: "CareerGraphUpload",
            meta: { requiresAuth: true },
            component: () => import("./views/CareerGraph/CareerGraphUpload")
        },
        {
            path: "/CareerGraphProject/:divisionId",
            name: "CareerGraphProject",
            meta: { requiresAuth: true },
            component: () => import("./views/CareerGraph/CareerGraphProject")
        },
        {
            path: "/CareerGraphEmployee/:projectId",
            name: "CareerGraphEmployee",
            meta: { requiresAuth: true },
            component: () => import("./views/CareerGraph/CareerGraphEmployee")
        },
        {
            path: "/CareerGraphView/:employeeId",
            name: "CareerGraphView",
            meta: { requiresAuth: true },
            component: () => import("./views/CareerGraph/CareerGraphView")
        },


        {
            path: "nominationFormView",
            name: "nominationFormView",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/nominationFormView"),
        },
        {
            path: "epfoFormView",
            name: "epfoFormView",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/epfoFormView"),
        },


        {
            path: "employeelist",
            name: "documentUploadedList",

            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/EmployeeList/list"),
            props: true,
        },
        {
            path: "employeeview",

            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/EmployeeList/listView"),
            props: true,
        },

        {
            path: "/addEmployee",
            name: "addEmployee",
            props: true,
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/addEmployee"),
        },
        {
            path: "/salaryComparison",
            name: "salaryComparison",
            props: true,
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/salaryComparison"),
        },
        {
            path: "/exited-employees",
            name: "exited-employees",
            props: true,
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/exitedEmployee"),
        },
        {
            path: "/probationReview",
            name: "probationReview",
            props: true,
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/probationReview"),
        },
        {
            path: "/probationReviewView",
            name: "probationReviewView",
            props: true,
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/probationReviewView"),
        },
        {
            path: "/probationReviewViewE",
            name: "probationReviewViewE",
            props: true,
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/probationReviewViewE"),
        },
        {
            path: "/viewEmployee",
            name: "viewEmployee",
            props: true,
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/viewEmployee"),
        },
        {
            path: "/Assign",
            name: "Assign",
            props: true,
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/Assign"),
        },


        {
            path: "/SubTeam",
            name: "SubTeam",
            props: true,
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/SubTeam"),
        },

        {
            path: "/SubTeam2",
            name: "SubTeam2",
            props: true,
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/SubTeam2"),
        },
        {
            path: "/teamHierarchy",
            name: "teamHierarchy",
            props: true,
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Employee/teamHierarchy"),
        },




        {
            path: "/ProductType",
            name: "ProductType",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Products/ProductType/productType"),
        },
        {
            path: "/addProducts",
            name: "addProducts",
            component: () =>
                import("./views/Products/addProduct"),
        },
        {
            path: "/products",
            name: "Products",
            component: () =>
                import("./views/Products/products"),
        },
        {
            path: "/promocode",
            name: "Promocode",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Products/Promocode/promocode"),
        },
        {
            path: "/product/:id",
            name: "Product",
            component: () =>
                import("./views/Products/product"),
            props: true,
        },
        {
            path: "/editProduct/:id",
            name: "EditProduct",
            component: () =>
                import("./views/Products/editProduct"),
            props: true,
        },
        {
            path: "/aboutUs",
            name: "aboutUs",
            component: () =>
                import("./views/About/about"),
        },
        {
            path: "/Video",
            name: "Video",
            component: () =>
                import("./views/About/video"),
        },
        {
            path: "/Announcements",
            name: "Announcements",
            component: () =>
                import("./views/About/announcements"),
        },
        {
            path: "/purchaseReports",
            name: "Purchases",
            component: () =>
                import("./views/Reports/Products/purchase"),
        },

        {
            path: "/quizDetails",
            name: "quizDetails",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Contest/quizApplications"),
        },
        {
            path: "/conservationClock",
            name: "conservationClock",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/ConservationClock/conservationClock"),
        },
        {
            path: "/viewQuiz",
            name: "viewQuiz",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Contest/viewQuiz"),
        },

        // NEW Mod

        {
            path: "/fake-gps/list",
            name: "Fake GPS List",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/FakeGps/fakeGpsList"),
        },
        {
            path: "/audit-logs",
            name: "Audit Logs",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/EmployeeManagement/AuditLogList"),
        },
        {
            path: "/admin/teams/list",
            name: "AdminTeamList",
            meta: { requiresAuth: true },
            component: () => import("./views/Admin/Teams/TeamList"),
        },
        {
            path: "/admin/teams/organogram/:id",
            name: "AdminTeamOrganogram",
            meta: { requiresAuth: true },
            component: () => import("./views/Admin/Teams/TeamOrganogram"),
        },
        {
            path: "/my-team/members",
            name: "MyTeamMembers",
            meta: { requiresAuth: true },
            component: () => import("./views/MyTeam/TeamMembers"),
        },
        {
            path: "/my-team/organogram",
            name: "MyTeamOrganogram",
            meta: { requiresAuth: true },
            component: () => import("./views/MyTeam/TeamOrganogram"),
        },

        {
            path: "/AutomationTools/Actions",
            name: "EmailActions",
            meta: { requiresAuth: true },
            component: () => import("./views/AutomationTools/Actions"),
        },
        {
            path: "/AutomationTools/AttendanceSettings",
            name: "AttendanceSettings",
            meta: { requiresAuth: true },
            component: () => import("./views/AutomationTools/AttendanceSettings"),
        },
        {
            path: "/AutomationTools/SendEmail",
            name: "SendEmail",
            meta: { requiresAuth: true },
            component: () => import("./views/AutomationTools/SendEmail"),
        },

        {
            path: "/Roles",
            name: "Roles",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/RolesandDepartments/roles"),
        },
        {
            path: "/AddDivision",
            name: "AddDivision",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Division/AddDivision"),
        },
        {
            path: "/Departments",
            name: "Departments",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/RolesandDepartments/departments"),
        },
        {
            path: "/Projects",
            name: "Projects",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Projects/projects"),
        },
        {
            path: "/Positions",
            name: "Designation",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/RolesandDepartments/positions"),
        },
        {
            path: "/SpecialPosition",
            name: "SpecialPosition",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/RolesandDepartments/SpecialPosition"),
        },

        {
            path: "/Profile",
            name: "Profile",
            component: () =>
                import("./components/Profile/profile"),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/ViewDA",
            name: "ViewDA",
            component: () =>
                import("./components/Profile/viewDA"),
            meta: {
                requiresAuth: true,
            },
        },

        {
            path: "/DisciplinaryActions",
            name: "DisciplinaryActions",
            component: () =>
                import("./views/DisciplinaryAction/disciplinaryActions"),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/ApplyLoan",
            name: "ApplyLoan",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/ApplyLoan"),
        },
        {
            path: "/ApplyAdvance",
            name: "ApplyForSalaryAdvance",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/ApplyAdvance"),
        },
        {
            path: "/EditAdvance",
            name: "EditAdvance",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/EditAdvance"),
        },
        {
            path: "/ViewsalaryAdvance",
            name: "ViewsalaryAdvance",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/advsalHr"),
        },
        {
            path: "/ViewloanRequest",
            name: "ViewloanRequest",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/loanreqView"),
        },
        {
            path: "/SalaryAdvanceRequest",
            name: "SalaryAdvanceRequest",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/SalaryAdvanceRequest"),
        },
        {
            path: "/TeamLoanRequest",
            name: "TeamLoanRequest",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/TeamLoanRequest.vue"),
        },
        {
            path: "/SalaryAdvanceRelease",
            name: "SalaryAdvanceRelease",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/SalaryAdvanceRelease"),
        },
        {
            path: "/LoanAmountRelease",
            name: "LoanAmountRelease",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/LoanAmountRelease"),
        },
        {
            path: "/LoanApplications",
            name: "LoanApplications",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/LoanApplications"),
        },
        {
            path: "/ViewLoan",
            name: "ViewLoan",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/ViewLoan"),
        },
        {
            path: "/ViewLoanApplication",
            name: "ViewLoanApplication",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/ViewLoanApplication"),
        },


        {
            path: "/MyLoanApplications",
            name: "MyLoanApplications",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/MyLoanApplications"),
        },

        {
            path: "/MySalaryAdvanceApplications",
            name: "MySalaryAdvanceApplications",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Loans/MySalaryAdvanceApplications"),
        },
        {
            path: "/Questions",
            name: "exitInterviewQuestions",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Interviews/Questions"),
        },
        {
            path: "/ExitInterview",
            name: "ExitInterview",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Interviews/ExitInterview"),
        },
        {
            path: "/AllExitInterviews",
            name: "AllExitInterviews",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Interviews/AllApplications"),
        },
        {
            path: "/Troubleshoot/Report",
            name: "TroubleshootReport",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Troubleshoot/TroubleshootReport"),
        },
        {
            path: "/Troubleshoot/MyTickets",
            name: "MyTroubleshootTickets",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Troubleshoot/MyTickets"),
        },
        {
            path: "/Troubleshoot/Admin/Manage",
            name: "ManageTroubleshootingTickets",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Troubleshoot/TroubleshootAdmin"),
        },
        {
            path: "/Payslips/Upload",
            name: "UploadPayslip",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Payslips/UploadPayslip"),
        },
        {
            path: "/Payslips/MyPayslips",
            name: "MyPayslips",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Payslips/MyPayslips"),
        },
        ],
    },

    {
        path: "/Assets/",
        props: true,
        component: () =>
            import("./layout/Default"),
        meta: {
            requiresAuth: true,
        },
        children: [{
            path: "AssetCategory",
            name: "AssetCategory",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Category/CategoryHome"),
        },
        {
            path: "AddAsset",
            name: "AddAsset",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Asset/AddAsset"),
        },
        {
            path: "Assets",
            name: "Assets",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Asset/AssetList"),
        },
        {
            path: "ViewAsset",
            name: "ViewAsset",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Asset/ViewAsset"),
        },
        {
            path: "ViewLog",
            name: "ViewLog",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Asset/LogList"),
        },
        {
            path: "EditAsset",
            name: "EditAsset",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Asset/EditAsset"),
        },
        {
            path: "Purchase",
            name: "Purchase",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Purchase/PurchaseList"),
        },
        {
            path: "AddPurchase",
            name: "AddPurchase",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Purchase/AddPurchase"),
        },
        {
            path: "Inventory",
            name: "Inventory",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Inventory/InventoryList"),
        },
        {
            path: "AssignAsset",
            name: "AssignAsset",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/AssignAsset/AssignAsset"),
        },

        {
            path: "ReAssignAsset",
            name: "ReAssignAsset",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/AssignAsset/ReAssignAsset"),
        },


        {
            path: "DeptInventory",
            name: "DeptInventory",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Inventory/DeptInventoryList"),
        },

        {
            path: "EmpInventory",
            name: "EmpInventory",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Inventory/EmpInventoryList"),
        },

        {
            path: "DonorList",
            name: "DonorList",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Donor/DonorList"),
        },





        {
            path: "RequestList",
            name: "RequestList",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Requests/RequestList"),
        },
        {
            path: "NewRequest",
            name: "NewRequest",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Requests/NewRequest"),
        },







        {
            path: "Dismantle",
            name: "Dismantle",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Dismantle/DismantleList"),
        },
        {
            path: "AddDismantle",
            name: "AddDismantle",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Dismantle/AddDismantle"),
        },
        {
            path: "MyQuery",
            name: "MyQuery",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Query/EmpQueriesList"),
        },
        {
            path: "HRQuery",
            name: "HRQuery",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Query/HRQueriesList"),
        },

        {
            path: "StockConsumed",
            name: "StockConsumed",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Assets/Dismantle/StockConsumed"),
        },
        ],
    },

    //Awards
    {
        path: "/Awards/",
        props: true,
        component: () =>
            import("./layout/Default"),
        meta: {
            requiresAuth: true,
        },
        children: [{
            path: "AwardList",
            name: "AwardList",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Awards/AwardList"),
        },],
    },
    //Policies
    {
        path: "/HRmanual",
        props: true,
        component: () =>
            import("./layout/Default"),
        meta: {
            requiresAuth: true,
        },
        children: [{
            path: "addPolicies",
            name: "addPolicies",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Policies/addPolicies"),
        },
        {
            path: "viewPolicies",
            name: "viewPolicies",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Policies/viewPolicies"),
        },
        ],
    },
    //perforance management reviews PMR
    {
        path: "/PMR",
        props: true,
        component: () =>
            import("./layout/Default"),
        meta: {
            requiresAuth: true,
        },
        children: [{
            path: "addPMR",
            name: "addPerformance Management Review",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/PMR/addPMR"),
        },
        {
            path: "viewPMR",
            name: "viewPerformance Management Review",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/PMR/viewPMR"),
        },
        ],
    },
    // Targets
    {
        path: "/Targets",
        props: true,
        component: () =>
            import("./layout/Default"),
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "myTarget",
                name: "myTarget",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/Targets/myTarget"),
            },
            {
                path: "addTarget",
                name: "addTarget",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/Targets/addTarget"),
            },
            {
                path: "teamTarget",
                name: "teamTarget",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/Targets/teamTarget"),
            },
            {
                path: "teamMembers",
                name: "teamMembersTargetDetails",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/Targets/teamMembers"),
            },
            {
                path: "viewTarget",
                name: "viewTarget",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/Targets/viewTarget"),
            },
            {
                path: "viewTeamTargets",
                name: "viewTeamTargets",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/Targets/viewTeamTargets"),
            },
            {
                path: "TargetLogs",
                name: "TargetLogs",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/Targets/TargetLogs"),
            },

        ],
    },


    // Excel Reports
    {
        path: "/ExcelReports",
        props: true,
        component: () =>
            import("./layout/Default"),
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "empReports",
                name: "empReports",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/ExcelReports/empReports"),
            },
            {
                path: "salary-comparison-report",
                name: "salary-comparison-report",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/ExcelReports/salaryComparison"),
            },
            {
                path: "lateArrivalPenalty",
                name: "lateArrivalPenaltyExcel",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/Attendance/lateArrivalPenalty"),
            },



        ],
    },

    // Blogs
    {
        path: "/Blogs",
        props: true,
        component: () =>
            import("./layout/Default"),
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "wildByte",
                name: "wildByte",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/Blogs/wildByte"),
            },

            // {
            //     path: "viewWildByte",
            //     name: "viewWildByte",
            //     meta: {
            //         requiresAuth: true,
            //     },
            //     component: () =>
            //         import("./views/Blogs/viewWildByte"),
            // },
            {
                path: "viewWildByte/:slug",
                name: "viewWildByte",
                meta: {
                    requiresAuth: true,
                },
                component: () =>
                    import("./views/Blogs/viewWildByte"),
                props: true 
            }



        ],
    },



    //Attendance
    {
        path: "/Attendance",
        props: true,
        component: () =>
            import("./layout/Default"),
        meta: {
            requiresAuth: true,
        },
        children: [{
            path: "teamAttendance",
            name: "teamAttendanceList",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/teamAttendance"),
        },
        {
            path: "leaveRequests",
            name: "leaveRequests",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/leaveRequests"),
        },
        {
            path: "LeaveBalance",
            name: "LeaveBalance",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/LeaveBalance"),
        },

        {
            path: "leaveRequestsDetails",
            name: "leaveRequestsDetails",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/leaveRequestsDetails"),
        },
        {
            path: "withdrawLeaveList",
            name: "withdrawLeaveList",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/withdrawLeaveList"),
        },
        {
            path: "withdrawLeaveDetails",
            name: "withdrawLeaveDetails",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/withdrawLeaveDetails"),
        },
        {
            path: "organizationDetails",
            name: "organizationDetails",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/organizationDetails"),
        },
        {
            path: "festivalLeaves",
            name: "festivalLeaves",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/festivalLeaves"),
        },
        {
            path: "importantDates",
            name: "importantDates",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/importantDates"),
        },
        {
            path: "travelRequests",
            name: "travelRequests",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/travelRequests"),
        },
        {
            path: "outofofficeRequests",
            name: "OutOfOfficeRequests",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/outofofficeRequests"),
        },
        {
            path: "travelRequestDetails",
            name: "travelRequestDetails",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/travelRequestDetails"),
        },
        {
            path: "addAssignees",
            name: "addAssignees",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/addAssignees"),
        },
        {
            path: "myTravelogue",
            name: "myTravelogue",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/myTravelogue"),
        },
        {
            path: "myOutofOffice",
            name: "myOutofOffice",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/myOutofOffice"),
        },
        {
            path: "myTravelDetails",
            name: "myTravelDetails",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/myTravelDetails"),
        },
        {
            path: "travelRequestForm",
            name: "travelRequestForm",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/travelRequestForm"),
        },
        {
            path: "outofofficeRequestForm",
            name: "outofofficeRequestForm",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/outofofficeRequestForm"),
        },
        {
            path: "myAttendance",
            name: "myAttendance",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/myAttendance"),
        },
        {
            path: "myLeaves",
            name: "myLeaveList",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/myLeaves"),
        },
        {
            path: "leaveForm",
            name: "leaveForm",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/leaveForm"),
        },
        {
            path: "leaveAddorUpdate",
            name: "leaveAddorUpdate",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/leaveAddorUpdate"),
        },
        {
            path: "assignDetails",
            name: "assignDetails",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/assignDetails"),
        },
        {
            path: "teamMembers",
            name: "teamMembers",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/teamMembers"),
        },
        {
            path: "teamMemberDetails",
            name: "teamMemberDetails",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/teamMemberDetails"),
        },
        {
            path: "teamMemberAttendance",
            name: "teamMemberAttendance",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/teamMemberAttendance"),
        },
        {
            path: "probation-form-f1",
            name: "probation-form-f1",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/probationFormA"),
        },
        {
            path: "probation-form-f2",
            name: "probation-form-f2",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/probationFormE"),
        },
        {
            path: "reportList",
            name: "reportList",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/reportList"),
        },
        {
            path: "lateArrivalPenalty",
            name: "lateArrivalPenalty",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/lateArrivalPenalty"),
        },
        {
            path: "lateArrivalPenaltyExcludeAdd",
            name: "lateArrivalPenaltyExcludeAdd",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/lateArrivalPenaltyExcludeAdd"),
        },
        {
            path: "lateArrivalPenaltyExcludeList",
            name: "lateArrivalPenaltyExcludeList",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import("./views/Attendance/lateArrivalPenaltyExcludeList"),
        },
        ],
    },
    {
        path: "/",
        props: true,
        component: () =>
            import("./layout/Authentication"),
        meta: {
            requiresAuth: false,
        },
        children: [{
            path: "login",
            name: "login",
            meta: {
                requiresAuth: false,
            },
            component: () =>
                import("./views/Authentication/Login"),
        },
        {
            path: "signup",
            name: "signup",
            meta: {
                requiresAuth: false,
            },
            component: () =>
                import("./views/Authentication/Signup"),
        },
        ],
    },
    {
        path: "/servererror",
        name: "servererror",
        props: true,
        component: () =>
            import("./layout/500"),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/privacyPolicy",
        name: "privacyPolicy",
        props: true,
        component: () =>
            import("./layout/privacyPolicy"),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "*",
        name: "404pagenotfound",
        props: true,
        component: () =>
            import("./layout/404"),
        meta: {
            requiresAuth: false,
        },
    },
    ],
    scrollBehavior() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0;
    },
});
// ─── Menu-based Route Authorization ────────────────────────────────────────────
// Routes always accessible to any authenticated user, regardless of their menus.
// Keep this list MINIMAL — sub-pages should be reached via in-app navigation only.
const COMMON_ROUTES = [
    "/",             // Dashboard root
    "/login",
    "/servererror",
    "/privacyPolicy",
    "/Profile",
    "/Targets/viewTarget",
    "/Targets/teamTarget",
    "/Targets/viewTeamTargets",
    "/Blogs/wildByte",
    "/Blogs/viewWildByte",
    "/viewApplication",
    "/viewVolunteerApplication",
    "/AutomationTools/Actions",
    "/AutomationTools/SendEmail",
    "/fake-gps/list",
    "/audit-logs",
    "/CareerGraphDivision",
    "/CareerGraphProject",
    "/CareerGraphEmployee",
    "/CareerGraphView",
    "/admin/teams",
    "/my-team",
];

/**
 * Extracts the list of allowed route paths from the menus array stored in Vuex.
 * Returns a Set of route strings (e.g. "/Attendance/leaveRequests").
 */
function getAllowedRoutesFromMenus(menus) {
    const allowed = new Set();
    if (!Array.isArray(menus)) return allowed;
    menus.forEach((menuBlock) => {
        const subs = menuBlock.submenus || menuBlock.subMenu || [];
        if (Array.isArray(subs)) {
            subs.forEach((sub) => {
                if (sub && sub.route) allowed.add(sub.route);
            });
        }
    });
    return allowed;
}

/**
 * Checks whether the given path is permitted. A path is permitted if:
 *  1. It matches (or starts with) a COMMON_ROUTES entry, OR
 *  2. It matches (or starts with) a route from the user's menus.
 */
function isRoutePermitted(path, menuRoutes) {
    // Normalize path: lowercase and remove trailing slashes,
    // but preserve root "/" so it doesn't become "" and match everything.
    const norm = (p) => {
        const stripped = p.replace(/\/+$/, "").toLowerCase();
        return stripped === "" ? "/" : stripped;
    };
    const normPath = norm(path);

    // Check common routes (some are prefixes for dynamic routes like /product/:id)
    for (const cr of COMMON_ROUTES) {
        const normCr = norm(cr);
        if (normPath === normCr || normPath.startsWith(normCr + "/")) return true;
    }

    // Check menu-derived routes
    for (const mr of menuRoutes) {
        const normMr = norm(mr);
        if (normPath === normMr || normPath.startsWith(normMr + "/")) return true;
    }

    return false;
}
// ────────────────────────────────────────────────────────────────────────────────

router.beforeEach((to, from, next) => {
    const leavingPage = ['addEmployee', 'viewEmployee'].includes(from.name);

    // Check if not entering any of these pages
    const notEnteringPage = !['addEmployee', 'viewEmployee'].includes(to.name);

    // If leaving any of these pages and not entering the same type of page
    if (leavingPage && notEnteringPage) {
        // Commit a Vuex store mutation to change the current page to an empty string
        store.commit('changeCurrentPage', '');
        // console.log('Change current page to an empty string');
    }
    const leavingDateStatus = ['leaveRequests', 'leaveRequestsDetails'].includes(from.name);

    // Check if not entering any of these pages
    const notEnteringDateStatus = !['leaveRequests', 'leaveRequestsDetails'].includes(to.name);
    if (leavingDateStatus && notEnteringDateStatus) {
        // Commit a Vuex store mutation to change the current page to an empty string
        store.commit('changeStatus', '');
        store.commit('changeDate', '');
        // console.log('Change current page to an empty string');
    }
    const leavingTravelDateStatus = ['travelRequests', 'travelRequestDetails'].includes(from.name);

    // Check if not entering any of these pages
    const notEnteringTravelDateStatus = !['travelRequests', 'travelRequestDetails'].includes(to.name);
    if (leavingTravelDateStatus && notEnteringTravelDateStatus) {
        // Commit a Vuex store mutation to change the current page to an empty string
        store.commit('changeTravelStatus', '');
        store.commit('changeTravelDate', '');
        // console.log('Change current page to an empty string');
    }
    const leavingPageTeam = ['teamMembers', 'teamMemberDetails'].includes(from.name);

    // Check if not entering any of these pages
    const notEnteringPageTeam = !['teamMembers', 'teamMemberDetails'].includes(to.name);
    if (leavingPageTeam && notEnteringPageTeam) {
        // Commit a Vuex store mutation to change the current page to an empty string
        store.commit('changeCurrentPageTeam', '');
        // console.log('Change current page to an empty string');
    }
    //new lines
    localStorage.setItem("PRE", from.path);

    // end  of newely added lines

    // ── 1. Unauthenticated users → redirect to login ──────────────────────────
    if (
        to.matched.some((route) => route.meta.requiresAuth == true) &&
        store.state.isLoggedIn == false
    ) {
        console.log(from);
        next({ name: "login", params: { lastPage: from } });
        return;
    }

    // ── 2. Validate session on every navigation (non-blocking) ────────────────
    if (store.state.isLoggedIn == true) {
        axios({
            method: "GET",
            url: "employee/profile/me",
            headers: {
                "x-auth-token": localStorage.getItem("token"),
            },
        })
            .then((response) => {
                if (!response.data.status) {
                    store.commit("sessionOut", true);
                    return;
                }
            })
            .catch((err) => {
                var msg = err;
                console.log(msg);
                // store.commit("sessionOut", true);
            });
    }

    // ── 3. Logged-in user on login/home → redirect to dashboard ──────────────
    if (
        (to.name == "login" || to.name == "home") &&
        store.state.isLoggedIn == true
    ) {
        next({ name: "dashboard" });
        return;
    }

    // ── 4. Menu-based route authorization — direct URL access only ───────────
    if (
        to.matched.some((route) => route.meta.adminOnly == true) &&
        store.state.isLoggedIn == true &&
        !store.getters.isAdmin
    ) {
        next({ name: "dashboard" });
        return;
    }

    // `from.name === null` means no previous in-app page exists, i.e. the user
    // typed this URL directly in the address bar or refreshed the page.
    // In-app navigation (clicking View buttons, links, etc.) always has a
    // from.name, so the check is skipped — allowing all sub-page navigation.
    if (
        store.state.isLoggedIn == true &&
        from.name === null &&
        to.matched.some((route) => route.meta.requiresAuth == true)
    ) {
        const menus = store.state.menus || [];
        // Only enforce when menus have been loaded (prevents locking out on cold load)
        if (menus.length > 0) {
            const menuRoutes = getAllowedRoutesFromMenus(menus);
            if (!isRoutePermitted(to.path, menuRoutes)) {
                console.warn(`[Router] Direct access denied to "${to.path}" – not in user menus.`);
                next({ name: "dashboard" });
                return;
            }
        }
    }

    next();
});

router.afterEach((to) => {
    const token = localStorage.getItem("token");
    if (token && to.name) {
        axios.post('/employee/audit/navigate', {
            pageName: to.name,
            route: to.path
        }, {
            headers: { 'x-auth-token': token }
        }).catch(err => {
            console.error("Failed to log navigation:", err);
        });
    }
});

export default router;